/**
 * PageHeader Component
 * Standardized page header with icon, title, subtitle, and actions
 */

import React from 'react';
import { typography } from '../../styles/typography';

export interface PageHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  className?: string;
}

export function PageHeader({
  icon,
  title,
  subtitle,
  actions,
  breadcrumbs,
  className = '',
}: PageHeaderProps) {
  return (
    <div className={`mb-6 ${className}`}>
      {breadcrumbs && <div className="mb-3">{breadcrumbs}</div>}
      
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h1 className={`${typography.pageTitle} flex items-center gap-3`}>
            {icon && <span className="h-8 w-8 text-primary-600 dark:text-primary-400">{icon}</span>}
            {title}
          </h1>
          {subtitle && <p className={typography.pageSubtitle}>{subtitle}</p>}
        </div>
        
        {actions && <div className="flex items-center gap-2 ml-4">{actions}</div>}
      </div>
    </div>
  );
}

